import apiHelper from '../helper/ApiHelper';

const HeadService = {
  async getHeads() {
    try {
      return await apiHelper('/heads');
    } catch (error) {
      console.error('Error fetching heads:', error);
      throw error;
    }
  },

  async createHead(head) {
    try {
      return await apiHelper('/heads', 'POST', head);
    } catch (error) {
      console.error('Error creating head:', error);
      throw error;
    }
  },

  async updateHead(headId, head) {
    try {
      console.log(headId, head)
      return await apiHelper(`/heads/${headId}`, 'PUT', head);
    } catch (error) {
      console.error('Error updating head:', error);
      throw error;
    }
  },

  async deleteHead(id) {
    try {
      console.log(id)
      return await apiHelper(`/heads/${id}`, 'DELETE');
    } catch (error) {
      console.error('Error deleting head:', error);
      throw error;
    }
  },
};

export default HeadService;